<template>
  <div class="letters-font">
    <div
      v-for="font in fonts"
      :key="font.value"
      :class="{
        'letters-font__item': true,
        'letters-font__item--selected': letterNumberArtwork.font === font.value
      }"
      data-testid="transfers-letter-font-item"
      @click="handleSelect(font)"
    >
      <div
        :class="{
          'letters-font__text': true,
          [`letters-font__text--${font.value}`]: true
        }"
      >
        ABCD
      </div>
      <span class="letters-font__label">{{ font.label }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useDtfStore } from "../store";

const props = defineProps({
  fonts: { type: Array, required: true }
});

const fonts = ref(props.fonts);

const store = useDtfStore();
const letterNumberArtwork = computed(() => store.letterNumberArtwork);

const handleSelect = option => {
  const font = option.value;
  store.updateArtworkValues({ index: 0, font });
  store.updateAllLetterPreviews();
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.letters-font {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow-x: auto;

  @include with-desktop {
    flex-wrap: wrap;
    overflow-x: unset;
  }

  &__item {
    display: flex;
    flex-direction: column;
    gap: 5px;
    border-radius: 8px;
    border: 1px solid $gray-label;
    padding: 12px 16px;
    text-align: center;
    cursor: pointer;
    min-width: 140px;
    height: 90px;

    &--selected {
      border-radius: 8px;
      border: 2px solid $primary-600;
      padding: 11px 15px;
    }
  }

  &__label {
    color: $text-black;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.3;
  }

  &__text {
    font-size: 28px;

    &--promesh {
      font-family: "Promesh";
    }

    &--emilio {
      font-family: "Emilio 20";
    }

    &--niconne {
      font-family: "Niconne";
    }

    &--squares-bold {
      font-family: "Squares Bold";
    }

    &--beantown {
      font-family: "Beantown";
    }

    &--octin-sports {
      font-family: "Oction Sports";
    }

    &--soccer-league {
      font-family: "Soccer League";
    }

    &--rueckwarzsalto {
      font-family: "Rueckwarzsalto";
    }

    &--facon {
      font-family: "Facon";
    }

    &--varsity-team {
      font-family: "Varsity Team";
    }
  }
}
</style>
